import {TimeSpan} from "@sparkware/app-utils";
import {CyClass} from "../../../../common/cy-classes";
import {SpacerBox} from "../../../basic-ui-components/layout/spacer.box";
import {useServices} from "../../../react-hooks/use-services.hook";
import {IModalDialogHandler} from "../../../services/dialog/dialog.service.interface";
import {ModalDialogActionsComponent} from "../../modal-dialog/modal-dialog-actions.component";
import {GamblingSessionLimitSummaryBox} from "../session-info/boxes/gambling-session-limits-summary.box";
import {GamblingSessionInfoComponent} from "../session-info/gambling-session-info.component";

interface IGamblingSessionLogoutDialogProps {
    dialogHandler: IModalDialogHandler;
    sessionDuration: TimeSpan;
    totalBets: number;
    totalWins: number;
    onLogout(): void;
    onCancel(): void;
}

export const GamblingSessionLogoutDialog: React.FC<IGamblingSessionLogoutDialogProps> = (props) => {
    const services = useServices();
    return (
        <GamblingSessionLimitSummaryBox>
            <SpacerBox height="1.5rem"/>

            <GamblingSessionInfoComponent
                sessionDuration={props.sessionDuration}
                totalWins={props.totalWins}
                totalBets={props.totalBets}
            />

            <ModalDialogActionsComponent
                primaryAction={{
                    className: 'cy-gambling-session-logout-button',
                    text: services.translation.translate('LOGOUT'),
                    onClick: props.onLogout
                }}
                secondaryAction={{
                    className: 'cy-gambling-session-cancel-button',
                    text: services.translation.translate('CANCEL'),
                    onClick: props.onCancel
                }} 
                buttonsOnSeparateLines={services.mediaQuery.lAndBelow}
                className={CyClass("cy-modal-dialog-buttons-area")}
                margin="2rem auto 0"
            />

        </GamblingSessionLimitSummaryBox>
    );
}